import classNames from 'classnames';
import React from 'react';
import type { ReactNode } from 'react';
import * as styles from './EmbedFooter.module.scss';
import Link from '../../utils/router/Link';
import useInternalCopyPaste from '../utils/useInternalCopyPaste';

interface EmbedFooterProps {
  className?: string;
  hasNativeFooter?: boolean;
  link?: string;
  icon: ReactNode;
  title: string;
  action?: ReactNode;
}

const EmbedFooter = ({
  className,
  hasNativeFooter,
  link,
  icon,
  title,
  action,
}: EmbedFooterProps) => {
  const setElement = useInternalCopyPaste();
  const linkContent = (
    <div className={styles.linkContent}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
    </div>
  );

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.hasNativeFooter]: hasNativeFooter,
      })}
    >
      {link ? (
        <Link className={styles.link} ref={setElement} to={link} newTab="ugc">
          {linkContent}
        </Link>
      ) : (
        <span className={styles.link}>{linkContent}</span>
      )}
      {!!action && <div className={styles.action}>{action}</div>}
    </div>
  );
};

export default EmbedFooter;
